import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

// Avoid CRA dev-overlay crashes from browser extensions (not app code).
// MetaMask sometimes throws from `chrome-extension://.../inpage.js`; we ignore those on localhost only.
if (process.env.NODE_ENV === "development" && window.location.hostname === "localhost") {
  window.addEventListener("error", (event) => {
    const e = event as ErrorEvent;
    const filename = e?.filename;
    const message = typeof e?.message === "string" ? e.message : "";
    const isExtension = typeof filename === "string" && filename.startsWith("chrome-extension://");
    const isMetaMaskMessage =
      message.includes("MetaMask") || message.includes("Failed to connect to MetaMask");
    if (isExtension || isMetaMaskMessage) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason: any = (event as PromiseRejectionEvent)?.reason;
    const stack = typeof reason?.stack === "string" ? reason.stack : "";
    const msg =
      typeof reason?.message === "string"
        ? reason.message
        : typeof reason === "string"
          ? reason
          : "";
    const isExtension = stack.includes("chrome-extension://");
    const isMetaMaskMessage =
      msg.includes("MetaMask") || msg.includes("Failed to connect to MetaMask");
    if (isExtension || isMetaMaskMessage) {
      event.preventDefault();
      event.stopImmediatePropagation?.();
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const store = configureStore({ reducer: rootReducer, devTools: true });
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* Empty PUBLIC_URL must not be passed as basename ""; let Router default to "/" */}
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
